import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";

import { Tabs, View } from "../../components/base";
import { useAppSelector } from "../../redux";

type AgentEvaluationTab = "evaluations" | "assignments" | "evaluate";

const evaluationTabs = [
  { id: "evaluations", label: "Evaluations" },
  { id: "assignments", label: "Assignments" },
  // TODO
  // { id: "evaluate", label: "Evaluate" },
];

export const AgentEvaluationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { agentId } = useParams<{ agentId?: string }>();
  const hasReleases = useAppSelector((state) => Object.values(state.release.entities).some((release) => release.agentId === agentId));

  const sectionPath = location.pathname.split("/evaluation/")[1] || "";
  const activeTab = (evaluationTabs.find((tab) => sectionPath.startsWith(tab.id))?.id || "evaluations") as AgentEvaluationTab;

  const handleTabChange = (tabId: string) => {
    if (tabId === activeTab) {
      return;
    }
    navigate(tabId);
  };

  return (
    <View className="h-full w-full overflow-hidden">
      <View className="flex flex-col gap-4 h-full min-h-0">
        {!hasReleases && (
          <View className="px-4 pt-4">
            <Tabs
              tabs={evaluationTabs}
              activeTab={activeTab}
              onChange={handleTabChange}
            />
          </View>
        )}

        <View className="flex-1 min-h-0 overflow-hidden">
          <Outlet />
        </View>
      </View>
    </View>
  );
};
